const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

let reloading = false;

function reloadOnce() {
  if (reloading) return;
  reloading = true;
  window.location.reload();
}

export function register(config) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  try {
    localStorage.removeItem('bb-release-pending');
  } catch (error) {
    /* private mode */
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
      navigator.serviceWorker.ready.then(() => {
        console.log('Band Bacon is being served from cache by a service worker.');
      });
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function notifyWaiting(registration, config) {
  if (config && config.onUpdate) {
    config.onUpdate(registration);
  }
}

function watchForUpdates(registration, config) {
  if (registration.waiting && navigator.serviceWorker.controller) {
    notifyWaiting(registration, config);
  }

  registration.onupdatefound = () => {
    const installingWorker = registration.installing;
    if (installingWorker == null) {
      return;
    }
    installingWorker.onstatechange = () => {
      if (installingWorker.state !== 'installed') {
        return;
      }
      if (navigator.serviceWorker.controller) {
        notifyWaiting(registration, config);
      } else if (config && config.onSuccess) {
        config.onSuccess(registration);
      }
    };
  };

  const check = () => {
    if (document.visibilityState !== 'visible') return;
    registration.update().catch(() => {});
  };
  document.addEventListener('visibilitychange', check);
  window.addEventListener('focus', check);
  window.addEventListener('pageshow', check);
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      watchForUpdates(registration, config);
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

export function applyWaitingUpdate(registration) {
  const worker = registration && registration.waiting;
  if (!worker) {
    reloadOnce();
    return;
  }

  navigator.serviceWorker.addEventListener('controllerchange', reloadOnce);
  worker.postMessage({ type: 'SKIP_WAITING' });
  window.setTimeout(reloadOnce, 1200);
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. Band Bacon is running in offline mode.');
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  navigator.serviceWorker.ready
    .then((registration) => {
      registration.unregister();
    })
    .catch((error) => {
      console.error(error.message);
    });
}
